<script>
  // import glasses from "img/glasses.jpg"
</script>

<section class="relative">
	<!-- <div class="flex w-full h-8 justify-start items-center"> -->
    <div class="w-full h-full absolute top-24">
      <h1 class="flex justify-center text-center text-6xl">Shop Eyeglasses Online </h1>
      <h1 class="flex justify-center text-center text-2xl mt-2">Prescription, Frames, & Sunglasses</h1>
      <div class="flex justify-center pt-40">
        <div class="bg-orange-600 text-white w-36 h-12 flex items-center justify-center mr-4 cursor-pointer">Shop Men</div>
        <div class="bg-orange-600 text-white w-36 h-12 flex items-center justify-center cursor-pointer">Shop Women</div>
      </div>
    </div>
		<img src="img/glasses.jpg" alt="glasses" class="px-2 h-1/4"/>
	<!-- </div> -->
</section>
